var dutyPlanningApt = function () {
    $('input:radio[name=Makeadutyplanningappointment__Dutyplanningaptdetails__Chooseanappointmentslot]').on('change', function () {
        if (!$("div#dutyPlanningAlert").hasClass("hide")) {
            $("div#dutyPlanningAlert").addClass('hide');
        }

    });
};